var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { LineItemStructure } from '../components/LineItemStructure';
import { Container } from '../../../common/styles/container';
import { Paragraph } from '../../../atoms/Paragraph';
// Styles
import { getBackgroundColorByRecordColor } from '../../../common/styles/getBackgroundColorByRecordColor';
import { getLineItemStylesByState } from './getLineItemStylesByState';
// Utils
import styled from 'styled-components';
export var StyledLineItem = styled(LineItemStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  box-sizing: border-box;\n  cursor: pointer;\n  height: 40px;\n  padding: 4px;\n  display: grid;\n  grid-template-columns: max-content max-content 1fr max-content;\n\n  ", ":first-child {\n    width: 4px;\n    height: 32px;\n    margin-right: ", ";\n    ", ";\n  }\n\n  ", " {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  ", "\n"], ["\n  background-color: ", ";\n  box-sizing: border-box;\n  cursor: pointer;\n  height: 40px;\n  padding: 4px;\n  display: grid;\n  grid-template-columns: max-content max-content 1fr max-content;\n\n  ", ":first-child {\n    width: 4px;\n    height: 32px;\n    margin-right: ", ";\n    ", ";\n  }\n\n  ", " {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "" + theme.backgroundUI;
}, Container, function (_a) {
    var barColor = _a.barColor;
    return (barColor ? '8px' : '0');
}, function (_a) {
    var barColor = _a.barColor, theme = _a.theme;
    return getBackgroundColorByRecordColor(barColor, theme);
}, Paragraph, function (_a) {
    var theme = _a.theme, state = _a.state;
    return getLineItemStylesByState(state, theme);
});
var templateObject_1;
//# sourceMappingURL=StyledLineItem.js.map